import React from 'react';
import WorkforceResourceOptimizationPage from './WorkforceResourceOptimizationPage';

const ResourceOptimizationProjectsPage = () => {
  return <WorkforceResourceOptimizationPage initialTab="projects" showTopTabs={false} />;
};

export default ResourceOptimizationProjectsPage;

